// Per-page renderer for "forecasting" — extracted from reportBuilder.js.
// Signature: async (api, doc, ctx) => { y, aiInsights, aiRecommendations }
import autoTable from 'jspdf-autotable';
import { NAVY, formatValue } from '../utils';
import { drawLineChart } from '../charts';

export async function renderForecasting(api, doc, ctx) {
  const { qs, filterDesc, cs, pw, page } = ctx;
  let y = ctx.y;
  let aiInsights = [];
  let aiRecommendations = [];

  try {
    const res = await api.get(`/analytics/forecast?${qs}&horizon=6`);
    const d = res.data;

    if (d.forecast?.length > 0) {
      const summary = d.summary || {};
      const insights = d.insights || {};

      autoTable(doc, {
        startY: y,
        head: [['Trend', 'Monthly Growth', 'Projected Total', 'Avg Monthly', 'Peak Month']],
        body: [[
          insights.trend || 'N/A',
          `${insights.monthly_growth_pct || 0}%`,
          formatValue(summary.projected_period_total || 0),
          formatValue(summary.avg_monthly_forecast || 0),
          summary.peak_month || 'N/A',
        ]],
        styles: { fontSize: 8, halign: 'center' },
        headStyles: { fillColor: NAVY },
        margin: { left: 14, right: 14 },
      });
      y = doc.lastAutoTable.finalY + 8;

      const chartData = [
        ...(d.historical || []).map(m => ({ label: m.month, value: m.total })),
        ...(d.forecast || []).map(m => ({ label: m.month, value: m.total })),
      ];
      if (chartData.length > 0) {
        y = drawLineChart(doc, 14, y, pw - 28, 65, chartData, { title: 'Historical & Forecast Spend' });
      }
    } else {
      doc.setFontSize(9);
      doc.setTextColor(100);
      doc.text('No forecast available. Visit the Forecasting page to generate one.', 14, y);
      y += 10;
    }
  } catch {
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('No forecast data available.', 14, y);
    y += 10;
  }

  return { y, aiInsights, aiRecommendations };
}
